import React, { useState, useEffect } from "react";
import { StandartButton } from "commons/form-controls";
import ControlButtons from "items/control-buttons/control-buttons"
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import CompanyTopicsTableContainer from "./company-topics-table/company-topics-table-container";
import CompanyDeletedTopicsTablesContainer from "./company-deleted-topics-table/company-deleted-topics-table-container";
import CompaniesTableContainer from "./companies-table/companies-table-container";
import s from "../admin.module.scss";
import AdminAccountsContainer from "../admin-accounts/admin-accounts-container";
import CompanyContainer from "./company/company-container";
import Paginator from "items/paginator/paginator";
import PaginatorContainer from "items/paginator/paginator-container";

const AdminCompanies = (props) => {
    const [companies, setCompanies] = useState(props.companies ? props.companies : null);
    const [topics, setTopics] = useState(props.topics ? props.topics : null)
    const [companyId, setCompanyId] = useState(props.isSuperadmin && props.adminCompanyId ? props.adminCompanyId : props.companyId)
    const [accounts, setAccounts] = useState(null)
    const [page, setPage] = useState(props.currentPage);
    const [showedCount, setShowedCount] = useState(props.showedItemsCount)

    useEffect(()=>{
        setCompanies(props.companies ? props.companies : null);
        //setCompanyTopics(props.companyTopics ? props.companyTopics : null)
        setCompanyId(props.isSuperadmin && props.adminCompanyId ? props.adminCompanyId : props.companyId)
        setTopics(props.topics ? props.topics : null);
        setAccounts(props.accounts ? props.accounts : null);
        setPage(props.currentPage);
        setShowedCount(props.showedItemsCount)
    }, [props.companies ,props.companyId, props.isSuperadmin, props.adminCompanyId, props.currentPage, props.showedItemsCount])

    const getCompanyContainer = (role) => {
        
        switch(role){
            case 'ROLE_SUPER_ADMIN':
                return <CompaniesTableContainer 
                                                sort={props.sortBy} 
                                                sortDirection={props.sortDirection} 
                                                setSortBy={props.setSortBy} 
                                                setSortDirection={props.setSortDirection} 
                                                status={props.status} 
                                                setSortByStatus={props.setSortByStatus} 
                                                searchText={props.searchText}
                                                searchByText={props.searchByText}
                                                setSearch={props.setSearch}
                                            />
            case 'ROLE_ADMIN':
                return <div>
                    {/*<CompanyContainer />*/}
                </div>
        }
    }

        const companyName = props.selectedLanguage === 'KAZ' ? <div className={s.titleRow}>
                                                                    {<CompanyContainer />}
                                                                    <span> </span>
                                                                    {props.getValue('COMPANY_1')}{' '}
                                                                </div> 
                                                            :   <div className={s.titleRow}>
                                                                    {props.getValue('COMPANY')}{' '}
                                                                    {<CompanyContainer />}
                                                                </div>

    
    const paginator = (type, e) => {
        if(type === 'changePage'){
            props.setPage(!isNaN(e.selected) ? e.selected : e-1);
        }
        else if(type === 'changeLimit'){
            setShowedCount(e);
            props.setShowedCount(e);
        }
    }

    return (
        <div className={s.Admin}>
            <div className={s.companiesList}>
                <div>
                    {getCompanyContainer(props.role)}
                </div>
            </div>
            { companyId ? <div>
                                { companyName }
                                <div className={s.tableBlock}>
                                    {
                                        props.selectedLanguage === 'KAZ' 
                                        ? <span>{props.companyName}{' '}{props.getValue('COMPANY_ACCOUNTS')}</span>
                                        : <span>{props.getValue('COMPANY_ACCOUNTS')}{' '}{props.companyName}</span>
                                    }
                                    
                                    <AdminAccountsContainer/>
                                    {props.accountId ? 
                                    <div className={s.tableBlock}>
                                        <span>{props.getValue('ACCOUNT_TOPICS')}</span>
                                        <CompanyTopicsTableContainer isAccountTopics={true} companyId={companyId}/>
                                    </div>
                                    : null}
                                </div>
                                <div className={s.tableBlock}>
                                    {
                                        props.selectedLanguage === 'KAZ'
                                        ? <span>{props.companyName}{' '}{props.getValue('COMPANY_TOPICS')}</span>
                                        : <span>{props.getValue('COMPANY_TOPICS')}{' '}{props.companyName}</span>
                                    }
                                    <CompanyTopicsTableContainer companyId={companyId}/>
                                    {props.topicId ? 
                                        <div className={s.tableBlock}>
                                            <span>{props.getValue('TOPIC_ACCOUNTS')}</span>
                                            <AdminAccountsContainer isTopicAccounts={true}/>
                                        </div> 
                                        : null}
                                </div>
                                <div className={s.tableBlock}>
                                    {
                                        <div>
                                            <PaginatorContainer callback={paginator} page={page} showedCount={showedCount} count={props.companyDeletedTopicsCount} getValue={props.getValue} />
                                            <div style={{marginTop: '20px'}}><CompanyDeletedTopicsTablesContainer /></div>
                                        </div>
                                    }
                                </div>
                            </div>
             : null }
        </div>
    )
}

export default AdminCompanies;